import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Smic } from '@shared/models/referentiel/smic';
import { SmicConfig } from '@features/referentiel/config/smic.config';

@Injectable({
  providedIn: 'root',
})
export class SmicService {
  constructor(private http: HttpClient) {}

  getAllSmics(): Observable<Smic[]> {
    return this.http.get<Smic[]>(SmicConfig.smicList);
  }
}
